import { BaseModel } from './base.model';
import { ChecklistModel } from './checklist.model';
import { QuestionModel } from './question.model';
import { QuestionResponseModel } from './question_response.model';
import { ChecklistResponseModel } from './question_response.model copy';
import { UserModel } from './user.model';

export class ActionPlanModel extends BaseModel {
    status: string;
    deadline: Date;
    end_at: Date;
    responsible_id: number;
    checklist_id: number;
    question_id: number;
    checklist_response_id: number;
    question_response_id: number;

    responsible: UserModel;
    checklist: ChecklistModel;
    question: QuestionModel;
    checklist_response: ChecklistResponseModel;
    question_response: QuestionResponseModel;
    observation: string;
    new_deadline: any;
    header_item_response: any[];
    responses: any[]; // action_plan_responses

    constructor(actionPlan?: ActionPlanModel) {
        super();
        this.status = actionPlan ? actionPlan.status : null;
        this.deadline = actionPlan ? actionPlan.deadline : null;
        this.end_at = actionPlan ? actionPlan.end_at : null;
        this.responsible_id = actionPlan ? actionPlan.responsible_id : null;
        this.checklist_id = actionPlan ? actionPlan.checklist_id : null;
        this.question_id = actionPlan ? actionPlan.question_id : null;
        this.checklist_response_id = actionPlan ? actionPlan.checklist_response_id : null;
        this.question_response_id = actionPlan ? actionPlan.question_response_id : null;
        this.responses = actionPlan ? actionPlan.responses : null;

        this.responsible = actionPlan ? actionPlan.responsible : new UserModel;
        this.checklist = actionPlan ? actionPlan.checklist : new ChecklistModel;
        this.question = actionPlan ? actionPlan.question : new QuestionModel;
        this.checklist_response = actionPlan ? actionPlan.checklist_response : new ChecklistResponseModel;
        this.question_response = actionPlan ? actionPlan.question_response : new QuestionResponseModel;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/action-plan.model.ts